import React, { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getService } from '../../../../parameters'
import SERVICES from '../../../../services.constants'
import { TAG_CLICK_USER_ACCOUNT_BUTTON } from '../../../analytics/analytics.tagids.constants'
import { USER_SCREENS } from '../../../../store/ui/ui.constants'
import { setUiUserScreen } from '../../../../store/ui/uiSlice'
import { loadUserFavorites, loadUserItineraryOptions } from '../../../../store/userAccount/userAccount.actions'
import { selectUserName } from '../../../../store/userAccount/userAccount.selectors'
import { noop } from '../../../../utils/function'
import TagActionLink from '../../../genericComponents/TagActionLink'
import arrowRight from '../../../genericComponents/assets/arrow-right.svg'
import powerOff from '../../../genericComponents/assets/power-off.svg'
import { useTemporaryVisible } from '../../../genericComponents/useTemporaryVisible'
import SVGIcon from '../../../svg/SVGIcon'
import { useAction } from '../../../utils/react-redux'
import UserPicture from '../../UserPicture'
import CloseUserAreaButton from '../../shared/CloseUserAreaButton'
import UserScreenContent from '../../shared/UserScreenContent'
import useKeycloak from '../../useKeycloak'
import sUserManageFavorite from '../userFavorites/UserManageFavorite.less'
import UserLogout from './UserLogout'
import s from './UserMenu.less'

const UserMenuItem = ({ action = noop, icon, label }) => (
  <li onClick={action} className={s.userMenuItem}>
    <SVGIcon icon={icon} className={s.userMenuItemIcon} />
    <div className={s.userMenuItemLabel}>{label}</div>
    <SVGIcon url={arrowRight} className={s.userMenuItemArrow} />
  </li>
)

const UserMenuAccount = ({ url, label, tagType }) => (
  <TagActionLink type={tagType} href={url} className={s.userMenuItemAccount}>
    {label}
  </TagActionLink>
)

const UserMenu = () => {
  const dispatch = useDispatch()
  const userName = useSelector(selectUserName)
  const execLoadUserFavorites = useAction(loadUserFavorites)
  const execLoadUserItineraryOptions = useAction(loadUserItineraryOptions)
  const { loaded, keycloak } = useKeycloak()
  const [visible, setVisible] = useTemporaryVisible()
  const [userMenuError, setUserMenuError] = useState()

  const accountUrl = getService(
    SERVICES.KEYCLOAK,
    `realms/mappy/mappy_account-redirection-service?token=${
      keycloak?.token
    }&referrer=web-login&logout_redirect_uri=${encodeURIComponent(
      window.location.href
    )}&delete_redirect_uri=${encodeURIComponent(window.location.origin)}`
  ).url

  const gotoItineraryOptionsScreen = useCallback(async () => {
    const loadItineraryOptionsResult = await execLoadUserItineraryOptions()

    if (loadItineraryOptionsResult?.error) {
      setVisible(true)
      setUserMenuError(loadItineraryOptionsResult.error)
    }

    dispatch(setUiUserScreen({ name: USER_SCREENS.itineraryOptions }))
  }, [])

  const gotoFavoritesScreen = useCallback(async () => {
    const loadFavoritesResult = await execLoadUserFavorites()

    if (loadFavoritesResult?.error) {
      setVisible(true)
      setUserMenuError(loadFavoritesResult.error)
    }

    dispatch(setUiUserScreen({ name: USER_SCREENS.favorites }))
  }, [])

  if (!loaded) return <></>

  return (
    <div className={s.root}>
      {visible && <div className={sUserManageFavorite.errorMessage}>{userMenuError}</div>}
      <CloseUserAreaButton />
      <UserScreenContent>
        <div className={s.content}>
          <div className={s.avatar}>
            <UserPicture />
          </div>
          <div className={s.username}>{userName}</div>
          <ul className={s.userMenu}>
            <UserMenuItem label={'Mes lieux favoris'} icon={'coeur'} action={gotoFavoritesScreen} />
            <UserMenuItem label={'Mes options de déplacement'} icon={'rouage'} action={gotoItineraryOptionsScreen} />
          </ul>
          <div className={s.userMenuFooter}>
            <UserMenuAccount label={'Gérer mon compte'} url={accountUrl} tagType={TAG_CLICK_USER_ACCOUNT_BUTTON} />
            <UserLogout>
              <div className={s.logout}>
                <span className={s.userMenuLogoutIcon}>
                  <SVGIcon url={powerOff} className={s.userMenuItemIcon} />
                </span>
                Se déconnecter
              </div>
            </UserLogout>
          </div>
        </div>
      </UserScreenContent>
    </div>
  )
}

export default UserMenu
